import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { RxfyScalar } from "react-rxk";
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { orderBy, search, any } from "keautils";

import { LinkMenuIndice } from "./link";
import { MenuItem, SubmenuItem } from "./menuItem";
import { ErrorBoundary } from "app/features/inicio/error";
export { MenuItem, SubmenuItem };
interface MenuIndiceProps {
    titulo: React.ReactNode;
    submenus: SubmenuItem[];
    match: match<{}>;
}
class MenuIndiceItems extends React.PureComponent<MenuIndiceProps, { search: string }> {
    constructor(props) {
        super(props);
        this.state = { search: "" };
    }
    render() {
        const path = this.props.match.path;
        const submenus = this.props.submenus;
        const subs = orderBy(submenus, x => x.titulo)
            .map(x => { return { ...x, items: orderBy(x.items, m => m.titulo).filter(x => search(this.state.search, x.titulo)) } })
            .filter(x => x.items.length > 0);

        return (
            <div>

                <kea.Title titulo={this.props.titulo} />
                <div className="row">
                    <div className="col-md-12">
                        <kea.Text addon={<i className={fa("search")} />} value={this.state.search} onChange={x => this.setState({ search: x })} placeholder="Búsqueda" disableFastInput={true} />
                    </div>
                </div>

                <div className="row">
                    {
                        subs
                            .map(x =>
                                <div className="col-md-12">
                                    <kea.Title titulo={x.titulo} />
                                    {
                                        x.items
                                            .map(m =>
                                                <LinkMenuIndice key={m.route} title={m.titulo} icon={m.icon} go={path + "/" + m.route + "/"} />
                                            )
                                    }
                                </div>
                            )
                    }
                </div>

            </div>
        )
    }
}

interface PropsNoRx {
    permisos: models.Rol;
    submenus: SubmenuItem[];
    match: match<{}>
    titulo?: React.ReactNode;
}
class MenuIndiceNoRx extends React.Component<PropsNoRx> {
    render() {
        const permisos = this.props.permisos;
        var submenus = this.props.submenus;
        submenus = submenus.map(x => { return { ...x, items: x.items.filter(x => x.visible == null || x.visible(this.props.permisos)) } });
        const items = submenus.map(x => x.items).reduce(function (a, b) { return a.concat(b); });
        const path = this.props.match.path;
        if (any(items, x => x.route.startsWith("/") || x.route.endsWith("/") || x.route.startsWith("."))) {
            throw new Error("Todas las rutas de un MenuIndice no deben de finalizar con '/' o '.'");
        }

        return (
            <div>
                <Route exact path={path} render={props =>
                    <MenuIndiceItems submenus={submenus} titulo={this.props.titulo} {...props} />
                } />

                {
                    items.map(x =>
                        <Route key={x.route} path={path + "/" + x.route} render={props => 
                            <ErrorBoundary>
                                {x.render(props)}
                            </ErrorBoundary>
                        
                        } />)
                }
            </div>
        );
    }
}

export interface Props {
    /**Elementos del menu */
    submenus: RxfyScalar<SubmenuItem[]>;

    match: match<{}>;
    /**Permisos. Si no se establece se toma por default el observable de la sesion actual */
    permisos?: RxfyScalar<models.Rol>;
    titulo?: RxfyScalar<React.ReactNode>;
}

/**Un menu en forma de una lista de links con iconos */
export const MenuIndice = kea.defaultProps(componentToRx(MenuIndiceNoRx), { permisos: resources.User.PermisoRx }) as React.ComponentClass<Props>


// WEBPACK FOOTER //
// ./app/features/componentes/menu/index.tsx